/**
 * Klarity design tokens.
 * Single source of truth for colours, motion and elevation so every surface
 * (styled-components + MUI `sx`) speaks the same language.
 * Primary = sand, Secondary = forest — unchanged from the original brand.
 */

export const color = {
  sand: '#e2d5c4',
  sandLight: '#f0e8df',
  sandDeep: '#c3b5a3',

  forest: '#4a7061',
  forestSoft: '#6c9284',
  forestDeep: '#2e5041',

  cream: '#f8f5f2',
  creamDeep: '#f2ece5',
  paper: '#ffffff',

  ink: '#2b2a27',
  inkSoft: '#6d6861',
  inkFaint: '#9c958c',

  line: 'rgba(74, 112, 97, 0.16)',
  lineSoft: 'rgba(43, 42, 39, 0.08)',

  success: '#4a7061',
  warning: '#b5843f',
  danger: '#b4544a',
} as const;

export const font = {
  display: '"Cormorant Garamond", "Playfair Display", Georgia, serif',
  body: '"Jost", "Quicksand", "Helvetica Neue", Arial, sans-serif',
} as const;

export const radius = {
  sm: '10px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  pill: '999px',
} as const;

export const shadow = {
  soft: '0 12px 34px rgba(58, 48, 38, 0.07)',
  lift: '0 26px 60px rgba(58, 48, 38, 0.16)',
  inset: 'inset 0 0 0 1px rgba(255, 255, 255, 0.5)',
  glow: '0 0 0 1px rgba(226, 213, 196, 0.9), 0 30px 70px rgba(74, 112, 97, 0.18)',
} as const;

/** Shared easing curves — keeps every transition on the same rhythm. */
export const ease = {
  out: 'cubic-bezier(0.22, 1, 0.36, 1)',
  inOut: 'cubic-bezier(0.65, 0, 0.35, 1)',
  spring: 'cubic-bezier(0.34, 1.4, 0.64, 1)',
} as const;

export const duration = {
  fast: '180ms',
  base: '320ms',
  slow: '620ms',
  reveal: '820ms',
} as const;

export const layout = {
  maxWidth: '1180px',
  gutter: '1.5rem',
} as const;

const tokens = { color, font, radius, shadow, ease, duration, layout };

export default tokens;
